import { Box, Container } from '@chakra-ui/react';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  // Cream working canvas: white cards/sections float on the warm canvas, matching
  // the Recommendations States mockup. minH="full" keeps it covering short pages.
  return (
    <Box bg="white" minH="full">
      <Container maxW="6xl" py={10}>
        {children}
      </Container>
    </Box>
  );
}
